import * as React from "react";
import { MarketTemplate } from "../../../../../data";
import { prepareEmptyMarket } from "../../../../../helpers";
import { renderOutrightBetButtons } from "./renderOutrightBetButtons";
export var renderOutrightMarkets = function (cardProps, buttonsHolderClass, componentPrefix) {
    var market = cardProps.markets.length > 0
        ? cardProps.markets[0]
        : prepareEmptyMarket(cardProps, MarketTemplate.ThreeBox, 0);
    market.template = MarketTemplate.ThreeBox;
    return (React.createElement("div", { key: componentPrefix + "__buttons-holder__" + cardProps.event.id, className: "rj-ev-list__" + componentPrefix + "__buttons-holder " + buttonsHolderClass, "data-uat": "div-ev-list-" + componentPrefix + "-buttons-holder" }, renderOutrightBetButtons(market, cardProps.handlers.betButton, componentPrefix, cardProps.hideLowOdds)));
};
//# sourceMappingURL=renderOutrightMarkets.js.map